import { render, staticRenderFns } from "./t-label-item.vue?vue&type=template&id=e7642a86&scoped=true&"
import script from "./t-label-item.vue?vue&type=script&lang=js&"
export * from "./t-label-item.vue?vue&type=script&lang=js&"
import style0 from "./t-label-item.vue?vue&type=style&index=0&id=e7642a86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7642a86",
  null
  
)

export default component.exports